module.exports = __webpack_public_path__ + "static/media/goose.2f14e48b.png";